module.exports = __webpack_public_path__ + "img/Boot Too Girdies.6fa3f8ab.png";